import { render, staticRenderFns } from "./PresentationWatch.vue?vue&type=template&id=34e0123a&"
import script from "./PresentationWatch.vue?vue&type=script&lang=js&"
export * from "./PresentationWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports